import { PublicPageLoader } from '@/features/public-pages/components/PublicPageLoader';

/**
 * Public Investors page (`/investors`), fully CMS-driven (MYN-255, MYN-214).
 * Every section renders from the `investors` page's content via the public
 * read API - no hardcoded copy lives here. Replaces the `PlaceholderPage`
 * stub MYN-211's CTA-routing fix registered at this route.
 * Loading/not-published/error states are shared across every public page via
 * `PublicPageLoader`.
 */
export function InvestorsPage() {
  return <PublicPageLoader slug="investors" />;
}
